/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------*/
export default [{
        url: '/dashboard',
        name: "Dashboard",
        slug: "dashboard",
        icon: "HomeIcon",
        i18n: "Dashboard",
    },
    {
        header: "Manage",
        i18n: "Manage",
        permission: "MaintainBackgrounds"
    },
    {
        url: '/sites',
        name: "Sites",
        slug: "sitesList",
        icon: "CompassIcon",
        i18n: "Sites",
    },
    {
        url: '/users',
        name: "Users",
        slug: "usersList",
        icon: "UsersIcon",
        i18n: "Users",
    },
    {
        url: '/documenttypes',
        name: "DocumentTypes",
        slug: "DocumentTypeList",
        icon: "PackageIcon",
        i18n: "DocumentTypes",
    },
    {
        url: '/languages',
        name: "Languages",
        slug: "languagesList",
        icon: "GlobeIcon",
        i18n: "Languages",
    },
    {
        url: '/classifications',
        name: "Classifications",
        slug: "classificationsList",
        icon: "BookmarkIcon",
        i18n: "Classifications",
    },
    {
        url: '/groups',
        name: "ModuleGroups",
        slug: "ModuleGroupList",
        icon: "LayersIcon",
        i18n: "ModuleGroups",
    },
    {
        url: '/courses',
        name: "Course",
        slug: "courseList",
        icon: "BookOpenIcon",
        i18n: "Courses",
    },
    {
        url: '/companies',
        name: "Companies",
        slug: "companiesList",
        icon: "BriefcaseIcon",
        i18n: "Companies",
    },
    {
        url: '/students',
        name: "Students",
        slug: "studentsList",
        icon: "UsersIcon",
        i18n: "Students",
    },
    {
        url: '/guardians',
        name: "Guardians",
        slug: "GuardiansList",
        icon: "UsersIcon",
        i18n: "Guardians",
    },
    {
        url: '/resourcecategory',
        name: "ResourceCategory",
        slug: "ResourceCategory",
        icon: "FolderPlusIcon",
        i18n: "ResourceCategory",
    },
    {
        url: '/additionalresources',
        name: "Additional Resources",
        slug: "additionalResources",
        icon: "FolderIcon",
        i18n: "AdditionalResources",
    },
    {
        url: '/practicalquestions',
        name: "Practical Questions",
        slug: "PracticalQuestion",
        icon: "EditIcon",
        i18n: "PracticalQuestions",
    },
    {
        url: '/sarsquestions',
        name: "SARS Questions",
        slug: "SARSQuestion",
        icon: "EditIcon",
        i18n: "SARSQuestions",
    },
    {
        url: '/vendors',
        name: "Vendors",
        slug: "Vendor",
        icon: "TagIcon",
        i18n: "Vendors",
    },
    {
        url: '/subscription-report',
        name: "Subscription Report",
        slug: "subscription-report",
        icon: "CreditCardIcon",
        i18n: "Subscription Report",
    },
    {
        header: "Assessment",
        i18n: "Assessment",
        permission: "AssessModerateEvaluate"
    },
    {
        url: '/studentDocs',
        name: "studentDocs",
        slug: "studentDocs",
        icon: "UsersIcon",
        i18n: "studentDocs",
    },
    {
        url: '/assign',
        name: "Assign",
        slug: "Assign",
        icon: "UsersIcon",
        i18n: "Assign",
    },
    {
        url: '/predefinedcomments',
        name: "PredefinedComments",
        slug: "PredefinedComment",
        icon: "MessageSquareIcon",
        i18n: "PredefinedComment",
    },
    {
        url: '/assessmentquestions',
        name: "LearnerReviewQuestions",
        slug: "LearnerReviewQuestions",
        icon: "EditIcon",
        i18n: "LearnerReviewQuestions",
    },
    {
        url: '/witnesstestimonyquestion',
        name: "WitnessTestimonyQuestion",
        slug: "WitnessTestimonyQuestion",
        icon: "EditIcon",
        i18n: "WitnessTestimonyQuestion",
    },
    {
        url: '/moduledocuments',
        name: "ModuleDocuments",
        slug: "ModuleDocuments",
        icon: "FileTextIcon",
        i18n: "ModuleDocuments",
    },
    {
        url: '/assesstask',
        name: "AssessTask",
        slug: "AssessTask",
        icon: "Edit3Icon",
        i18n: "AssessTask",
    },
    {
        url: '/moderatetask',
        name: "ModerateTask",
        slug: "ModerateTask",
        icon: "Edit3Icon",
        i18n: "ModerateTask",
    },
    {
        url: '/evaluatetask',
        name: "Evaluate",
        slug: "Evaluate",
        icon: "CheckCircleIcon",
        i18n: "Evaluate",
    },
    {
        header: "Marketing",
        i18n: "Marketing",
        permission: "MaintainMarketingVideos"
    },
    {
        url: '/marketingcontent',
        name: "ManageVideos",
        slug: "MarketingVideos",
        icon: "VideoIcon",
        i18n: "ManageVideos",
    },
    {
        header: "CourseBuilder",
        i18n: "CourseBuilder",
        permission: "MaintainBackgrounds"
    },
    {
        url: '/bulkuploadcourse',
        name: "BulkUploadCourses",
        slug: "BulkUploadCourses",
        icon: "UploadCloudIcon",
        i18n: "BulkUploadCourses",
    },
    {
        url: '/bulkuploadschedules',
        name: "BulkUploadSchedules",
        slug: "BulkUploadSchedules",
        icon: "UploadCloudIcon",
        i18n: "BulkUploadSchedules",
    },
    {
        url: '/selectcourse',
        name: "SelectCourse",
        slug: "browseCourse",
        icon: "GridIcon",
        i18n: "SelectCourse",
    },
    {
        url: '/builder',
        name: "CourseBuilder",
        slug: "courseBuilder",
        icon: "Share2Icon",
        i18n: "CourseBuilder",
    },
    {
        url: '/premiumContent',
        name: "PremiumContent",
        slug: "premiumContent",
        icon: "DollarSignIcon",
        i18n: "PremiumContent",
    },
    {
        url: '/backgrounds',
        name: 'BackgroundList',
        slug: "BackgroundList",
        icon: "ImageIcon",
        i18n: "Background",
    },
    {
        url: '/music',
        name: "MusicList",
        slug: "MusicList",
        icon: "MusicIcon",
        i18n: "Music",
    },
    {
        url: '/scenes',
        name: "SceneList",
        slug: "SceneList",
        icon: "FilmIcon",
        i18n: "Scene",
    },
    {
        url: '/navigations',
        name: "NavigationList",
        slug: "NavigationList",
        icon: "MapIcon",
        i18n: "Navigation",
    },
    {
        url: '/characters',
        name: "Maintain Characters",
        slug: "charactersList",
        icon: "SmileIcon",
        i18n: "Characters",
    },
    {
        url: '/videos',
        name: "Video",
        slug: "videoList",
        icon: "VideoIcon",
        i18n: "Video",
    },
    {
        url: '/ispringquizzes',
        name: "iSpringQuizList",
        slug: "iSpringQuizList",
        icon: "CheckSquareIcon",
        i18n: "iSpringQuiz",
    },
    {
        url: '/ispringpresentations',
        name: "iSpringPresentationList",
        slug: "iSpringPresentationList",
        icon: "LoaderIcon",
        i18n: "iSpringPresentation",
    },
    {
        url: '/documents',
        name: "DocumentList",
        slug: "DocumentList",
        icon: "FileTextIcon",
        i18n: "Document",
    },
    {
        url: '/quizzes',
        name: "QuizList",
        slug: "QuizList",
        icon: "EditIcon",
        i18n: "Quiz",
    },
    {
        header:"AddShortCourse",
        i18n: "AddShortCourse",
        permission:"CEPAdmin"
    },
    {
        url: '/add-shortcourse',
        name: "addShortCourse",
        slug: "addShortCourse",
        icon: "AwardIcon",
        i18n: "AddShortCourse",
    },
    {
        url: '/shortcourses',
        name: "Short Courses",
        slug: "shortCourseList",
        icon: "AwardIcon",
        i18n: "ShortCourseList",
    },
    {
      url: '/add-bundle',
      name: "Add Shortcourse Bundles",
      slug: "addshortCourseBundle",
      icon: "AwardIcon",
      i18n: "AddBundle",
    },
    {
      url: '/shortcourse-bundles',
      name: "Shortcourse Bundles",
      slug: "shortcourseBundles",
      icon: "PackageIcon",
      i18n: "BundleList",
    },
    {
        header:"Monitor",
        i18n: "Monitor",
        permission:"Monitor"
    },
    {
        url: '/studentdocuments-monitor',
        name: "studentDocs",
        slug: "studentDocs",
        icon: "FileTextIcon",
        i18n: "studentDocs",
    },
    {
        url: '/assessments-monitor',
        name: "Assessments",
        slug: "Assessments",
        icon: "Edit3Icon",
        i18n: "Assessments",
    },
    {
        header: "Mobile Plans",
        i18n: "MobilePlans",
        permission: "CEPAdmin"
    },
    {
        url: '/data-plan-banner',
        name: "Banners",
        slug: "Banners",
        icon: "SmartphoneIcon",
        i18n: "Banners",
    },
    {
        url: '/dataplans',
        name: "Data Plans",
        slug: "Data Plans",
        icon: "SmartphoneIcon",
        i18n: "DataPlans",
    },
    {
        header: "Reports",
        i18n: "Reports",
        permission: "Monitor"
    },
    {
        header: "Reports",
        i18n: "Reports",
        permission: "ViewReports"
    },
    {
        url: '/reports',
        name: "View Reports",
        slug: "View Reports",
        icon: "FileTextIcon",
        i18n: "ViewReports",
    },
]